/**
 * Cart Drawer — Canada BBQing
 * Handles: open on add-to-cart, quantity changes, remove items
 * Uses Shopify Section Rendering API for live updates
 */

(function() {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var DRAWER_ID = 'cart-drawer';

  /* Flag: true while we're doing an internal qty/remove change inside the drawer.
     Prevents the cartcount:update listener from re-opening the drawer. */
  var _internalOp = false;

  function getDrawerEl() {
    return document.getElementById(DRAWER_ID);
  }

  function getBody() {
    var drawer = getDrawerEl();
    return drawer ? drawer.querySelector('[data-cart-drawer-body]') : null;
  }

  /*  Section Rendering API  */
  function refreshDrawer(openAfter) {
    var url = window.location.pathname + '?sections=' + SECTION_ID;
    return fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        // Try exact key first, then fall back to first key in response
        var html = data[SECTION_ID];
        if (!html) {
          var keys = Object.keys(data);
          if (keys.length > 0) html = data[keys[0]];
        }
        if (!html) {
          var b = getBody();
          if (b) b.classList.remove('cd-body--loading');
          return;
        }

        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var newBody = tmp.querySelector('[data-cart-drawer-body]');
        var currentBody = getBody();
        if (newBody && currentBody) {
          // Preserve scroll position of the items list
          var itemsList = currentBody.querySelector('.cd-items');
          var scrollTop = itemsList ? itemsList.scrollTop : 0;

          currentBody.innerHTML = newBody.innerHTML;
          currentBody.classList.remove('cd-body--loading');

          // Restore scroll position
          var newItemsList = currentBody.querySelector('.cd-items');
          if (newItemsList && scrollTop) {
            newItemsList.scrollTop = scrollTop;
          }
        }

        // Update the label (cart count)
        var newLabel = tmp.querySelector('.overlay-drawer__label');
        var drawer = getDrawerEl();
        if (drawer && newLabel) {
          var currentLabel = drawer.querySelector('.overlay-drawer__label');
          if (currentLabel) {
            currentLabel.innerHTML = newLabel.innerHTML;
          }
        }

        bindDrawerEvents();

        bindCaaEvents();
        loadRecommendations();

        if (openAfter) {
          openDrawer();
        }
      })
      .catch(function(err) {
        console.error('Cart drawer refresh error:', err);
        var b = getBody();
        if (b) b.classList.remove('cd-body--loading');
      });
  }

  function openDrawer() {
    var el = getDrawerEl();
    if (!el) return;
    if (typeof el.open === 'function') {
      el.open();
    } else {
      // Fallback: set attribute directly
      el.setAttribute('open', 'true');
    }
  }

  /*  Cart API helpers  */
  function cartChange(key, quantity) {
    var body = getBody();
    if (body) body.classList.add('cd-body--loading');

    _internalOp = true;

    return fetch((window.Shopify.routes.root || '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      dispatchCartCount(cart.item_count);
      return refreshDrawer(false);
    })
    .catch(function(err) {
      console.error('Cart change error:', err);
      var b = getBody();
      if (b) b.classList.remove('cd-body--loading');
    })
    .then(function() {
      // Always reset after the full chain (including refreshDrawer) completes
      _internalOp = false;
    });
  }

  function dispatchCartCount(count) {
    window.dispatchEvent(new CustomEvent('cartcount:update', {
      detail: { item_count: count }
    }));
  }

  /*  Event binding for drawer content  */
  function bindDrawerEvents() {
    var body = getBody();
    if (!body) return;

    // Quantity minus
    body.querySelectorAll('[data-cd-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-cd-key');
        var qty = parseInt(btn.getAttribute('data-cd-qty'), 10);
        var newQty = Math.max(0, qty - 1);
        cartChange(key, newQty);
      });
    });

    // Quantity plus
    body.querySelectorAll('[data-cd-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-cd-key');
        var qty = parseInt(btn.getAttribute('data-cd-qty'), 10);
        cartChange(key, qty + 1);
      });
    });

    // Remove
    body.querySelectorAll('[data-cd-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-cd-key');
        cartChange(key, 0);
      });
    });

    // Continue Shopping button (empty state) — rebind close after innerHTML refresh
    var closeBtn = body.querySelector('[data-drawer-close-button]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        var drawer = getDrawerEl();
        if (drawer) {
          if (typeof drawer.close === 'function') {
            drawer.close();
          } else {
            drawer.setAttribute('open', 'false');
          }
        }
      });
    }
  }

  /*  Complementary product recommendations  */
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function loadRecommendations() {
    var body = getBody();
    if (!body) return;

    var container = body.querySelector('[data-cd-recommendations]');
    if (!container) return;

    // Collect product IDs already in cart
    var cartItems = body.querySelectorAll('[data-cd-item]');
    var cartProductIds = [];
    var lastProductId = null;

    cartItems.forEach(function(el) {
      var pid = el.getAttribute('data-cd-product-id');
      if (pid) {
        cartProductIds.push(pid);
        lastProductId = pid;
      }
    });

    if (!lastProductId) {
      container.innerHTML = '';
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = root + 'recommendations/products.json?product_id=' + lastProductId + '&limit=6&intent=complementary';

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products;
        if (!products || !products.length) {
          container.innerHTML = '';
          return;
        }

        // Filter out products already in cart, limit to 2
        var filtered = [];
        for (var i = 0; i < products.length && filtered.length < 2; i++) {
          if (cartProductIds.indexOf(String(products[i].id)) === -1) {
            filtered.push(products[i]);
          }
        }

        if (!filtered.length) {
          container.innerHTML = '';
          return;
        }

        var html = '<div class="cd-recs">';
        html += '<p class="cd-recs__heading">Complete Your Kit</p>';
        html += '<div class="cd-recs__list">';

        filtered.forEach(function(product) {
          var variant = product.variants[0];
          var imgSrc = product.featured_image ? product.featured_image + (product.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=120' : '';
          var productUrl = product.url || ('/products/' + product.handle);

          var priceHtml = '<span class="money">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceHtml = '<span class="money">' + formatMoney(variant.price) + '</span>';
            priceHtml += '<span class="cd-recs__price-compare money">' + formatMoney(variant.compare_at_price) + '</span>';
          }

          html += '<div class="cd-recs__item">';
          html += '<div class="cd-recs__img"><a href="' + productUrl + '">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') + '</a></div>';
          html += '<div class="cd-recs__details">';
          html += '<p class="cd-recs__title"><a href="' + productUrl + '">' + product.title.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;') + '</a></p>';
          html += '<p class="cd-recs__price">' + priceHtml + '</p>';
          html += '</div>';
          html += '<button type="button" class="cd-recs__add" data-cd-rec-add data-variant-id="' + variant.id + '">Add</button>';
          html += '</div>';
        });

        html += '</div></div>';
        container.innerHTML = html;

        // Bind Add buttons
        container.querySelectorAll('[data-cd-rec-add]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var variantId = btn.getAttribute('data-variant-id');
            if (!variantId) return;

            btn.classList.add('cd-recs__add--adding');
            btn.textContent = '...';

            _internalOp = true;

            fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { '_added_via': 'complete-your-kit-cart-drawer' } }] })
            })
            .then(function(r) { return r.json(); })
            .then(function() {
              return fetch(root + 'cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              dispatchCartCount(cart.item_count);
              return refreshDrawer(false);
            })
            .catch(function(err) {
              console.error('Cart rec add error:', err);
              btn.classList.remove('cd-recs__add--adding');
              btn.textContent = 'Add';
            })
            .then(function() {
              _internalOp = false;
            });
          });
        });
      })
      .catch(function(err) {
        console.error('Cart recommendations error:', err);
        container.innerHTML = '';
      });
  }

  /*  Intercept add-to-cart  */
  function handleAddToCart() {
    // Primary trigger: cartcount:update on window.
    // Fired by Empire's AddToCartFlyout AND by our own dispatchCartCount.
    // We skip events from our own internal qty/remove changes via _internalOp flag.
    // dispatchEvent is synchronous so the flag is still true when this runs.
    window.addEventListener('cartcount:update', function() {
      if (_internalOp) return;
      refreshDrawer(true);
    });

    // Also catch <product-form> success (high-variant / flex PDP pages).
    // This ensures the cart count is updated for pages using <product-form>.
    document.addEventListener('product-form:submit:success', function(e) {
      if (e.detail && e.detail.cart) {
        _internalOp = true; // prevent cartcount:update from double-firing
        dispatchCartCount(e.detail.cart.item_count);
        _internalOp = false;
      }
      refreshDrawer(true);
    });

    // Prevent redirect to /cart page (let the drawer handle it instead)
    document.addEventListener('product-form:cart:navigate', function(e) {
      if (!window.CART_REDIRECTION_ENABLED) {
        e.preventDefault();
      }
    });
  }

  /*  CAA Member Validation (drawer)  */
  var CAA_API_URL = 'https://caa-shopify-app.vercel.app';
  var CAA_SESSION_KEY = 'caa_membership_validated';

  function bindCaaEvents() {
    var body = getBody();
    if (!body) return;

    var container = body.querySelector('[data-cd-caa]');
    if (!container) return;

    var input = container.querySelector('[data-cd-caa-input]');
    var spinner = container.querySelector('[data-cd-caa-spinner]');
    var status = container.querySelector('[data-cd-caa-status]');
    if (!input) return;

    // Mark as bound to prevent duplicate listeners
    if (input.dataset.caaBound) {
      return;
    }
    input.dataset.caaBound = 'true';

    // Prevent Empire's overlay-drawer focus trap and backdrop handlers
    // from stealing focus when clicking the CAA input
    container.addEventListener('mousedown', function(e) {
      e.stopPropagation();
    });
    container.addEventListener('touchstart', function(e) {
      e.stopPropagation();
    }, { passive: true });
    input.addEventListener('click', function(e) {
      e.stopPropagation();
      input.focus();
    });

    var lastValidated = '';

    // Restore from session
    try {
      var saved = sessionStorage.getItem(CAA_SESSION_KEY);
      if (saved) {
        lastValidated = saved;
        var formatted = saved.replace(/(\d{4})(?=\d)/g, '$1 ');
        input.value = formatted;
        input.classList.add('cd-caa__input--valid');
        showCaaStatus(status, 'CAA membership applied — 10% discount active', 'success');
      }
    } catch (e) {}

    input.addEventListener('input', function(e) {
      var value = e.target.value.replace(/\D/g, '');
      value = value.substring(0, 16);
      value = value.replace(/(\d{4})(?=\d)/g, '$1 ');
      e.target.value = value;

      var clean = value.replace(/\s/g, '');
      input.classList.remove('cd-caa__input--valid', 'cd-caa__input--error');
      status.style.display = 'none';

      if (clean.length < 16 && lastValidated) {
        lastValidated = '';
        clearCaaSession();
        clearCaaCartAttribute();
      }

      if (clean.length === 16 && clean !== lastValidated) {
        validateCaa(clean, input, spinner, status, function(number) {
          lastValidated = number;
        });
      }
    });

  }

  function validateCaa(number, input, spinner, status, onSuccess) {
    spinner.style.display = 'block';

    fetch(CAA_API_URL + '/api/validate-member', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ membershipNumber: number })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      spinner.style.display = 'none';
      if (data.valid) {
        input.classList.add('cd-caa__input--valid');
        showCaaStatus(status, 'CAA membership applied — 10% discount active', 'success');
        saveCaaSession(number);
        onSuccess(number);

        // Set cart attribute, then refresh drawer to show discounted prices
        updateCaaCartAttribute(number).then(function() {
          _internalOp = true;
          refreshDrawer(false).then(function() {
            _internalOp = false;
          });
        });
      } else {
        input.classList.add('cd-caa__input--error');
        showCaaStatus(status, data.error || 'Membership not found', 'error');
        clearCaaSession();
        clearCaaCartAttribute();
      }
    })
    .catch(function(err) {
      console.error('CAA validation error:', err);
      spinner.style.display = 'none';
      input.classList.add('cd-caa__input--error');
      showCaaStatus(status, 'Unable to validate. Try again.', 'error');
    });
  }

  function showCaaStatus(el, msg, type) {
    el.textContent = msg;
    el.className = 'cd-caa__status cd-caa__status--' + type;
    el.style.display = 'block';
  }

  function saveCaaSession(number) {
    try { sessionStorage.setItem(CAA_SESSION_KEY, number); } catch (e) {}
  }

  function clearCaaSession() {
    try { sessionStorage.removeItem(CAA_SESSION_KEY); } catch (e) {}
  }

  function updateCaaCartAttribute(number) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'CAAMembership': number } })
    }).then(function(r) {
      return r.json();
    }).catch(function() {});
  }

  function clearCaaCartAttribute() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'CAAMembership': '' } })
    }).catch(function() {});
  }

  /*  Init  */
  function init() {
    bindDrawerEvents();
    bindCaaEvents();
    loadRecommendations();
    handleAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
